export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';

export const toggleDrawer = () => ({
    type: TOGGLE_DRAWER,
});